import { useSession } from "@/services/auth0/session";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

export const useSendPasswordResetEmail = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const { token } = useSession();

  return useMutation({
    mutationFn: async (userId: string) => {
      await axios.post(
        `${import.meta.env.VITE_API_URL}/api/v1/users/${userId}/send-password-reset-email-customer`,
        {
          userId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    },
    onSuccess: () => {
      onSuccess?.();
    },
  });
};
